import { css, SerializedStyles } from '@emotion/core';
import typography from '../../utils/typography';
import { FormControlContextType } from '../form_control_context';

const styles = ({
  focused,
  multiline,
  separateLabel,
  theme,
}: FormControlContextType): SerializedStyles => {
  const borderWidth = focused ? '2px' : '1px';

  const hiddenPlaceholder = {
    opacity: 0,
  };

  const visiblePlaceholder = {
    opacity: 1,
  };

  const inputType = multiline ? 'textarea' : 'input';

  return css({
    display: 'block',
    ...typography(theme).label,
    lineHeight: theme.lineHeightThree,
    width: '100%',

    ...(!separateLabel && {
      'label + .vn-input input, label + .vn-textarea': {
        padding: `calc(${theme.orbitalThree} - ${borderWidth})`,
        paddingRight: theme.orbitalThree,
        paddingBottom:
          theme.orbitalOne === 0
            ? `calc(${theme.layout.size1} - ${borderWidth})`
            : `calc(${theme.orbitalOne} - ${borderWidth})`,
        paddingTop: `calc(${theme.orbitalTwo} + ${theme.orbitalThree} - ${borderWidth})`,
      },
    }),

    [`label[data-focused='false'] + .vn-${inputType} ${inputType}`]: {
      '&::placeholder': hiddenPlaceholder,
      '&::-webkit-input-placeholder': hiddenPlaceholder,
      '&::-moz-placeholder': hiddenPlaceholder,
      '&:-ms-input-placeholder': hiddenPlaceholder,
      '&::-ms-input-placeholder': hiddenPlaceholder,
      '&:focus::placeholder': visiblePlaceholder,
      '&:focus::-webkit-input-placeholder': visiblePlaceholder,
      '&:focus::-moz-placeholder': visiblePlaceholder,
      '&:focus::-ms-input-placeholder': visiblePlaceholder,
    },
  });
};

export default styles;
